
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 92 92","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25.955 68.32c12.327 11.071 31.294 10.052 42.365-2.275 11.07-12.327 10.052-31.294-2.275-42.365-12.327-11.07-31.294-10.052-42.365 2.275C12.61 38.282 13.628 57.25 25.955 68.32z","stroke":"#0275D8","stroke-width":"4","stroke-dasharray":"141.37 49.12"}})])
          )
        }
      }
    